import { render, staticRenderFns } from "./SerialNumber.vue?vue&type=template&id=c3b3243a&scoped=true"
import script from "./SerialNumber.vue?vue&type=script&lang=ts"
export * from "./SerialNumber.vue?vue&type=script&lang=ts"
import style0 from "./SerialNumber.vue?vue&type=style&index=0&id=c3b3243a&prod&scoped=true&lang=css"
import style1 from "./SerialNumber.vue?vue&type=style&index=1&id=c3b3243a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b3243a",
  null
  
)

export default component.exports